import {SagaIterator} from 'redux-saga';
import {call} from 'typed-redux-saga';
import {takeLatestF} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';

import {ExportXlsByFilterAction} from '../actions';
import Api from '../api';
import {handleSuccess} from './utils/exportSagaUtils';

function* execute({payload: {filter}}: ExportXlsByFilterAction): SagaIterator {
    const response = yield* call(Api.exportXlsByFilter, filter);

    yield* response.isSuccess
        ? call(handleSuccess, response)
        : call(handleResponseError, response, 'Export Xls');
}

export function* exportXlsByFilterSaga(): SagaIterator {
    yield takeLatestF('measurement/EXPORT_XLS_BY_FILTER', execute);
}
